export default __webpack_public_path__ + "static/media/1825.62fdd228.png";